export interface RouteConfig {
    path: string
    page: string
    auth?: boolean
    /** Route is for guests only; authed users get redirected away. */
    guestOnly?: boolean
}

export const PUBLIC_ROUTES: RouteConfig[] = [
    { path: '/', page: 'index.page' },
    { path: '/products', page: 'products.page' },
    { path: '/login', page: 'Login/login.page', guestOnly: true },
    { path: '/sign-up', page: 'Signup/sign-up.page', guestOnly: true },
    { path: '/sign-up-success', page: 'Signup/sign-up-success.page', guestOnly: true },
    { path: '/reset-password', page: 'ResetPassword/reset-password.page', guestOnly: true },
    { path: '/reset-password-success', page: 'ResetPassword/reset-password-success.page', guestOnly: true },
    { path: '/learn', page: 'learn.page' },
    { path: '/contact-us', page: 'contact-us.page' },
    { path: '/faqs', page: 'faqs.page' },
    { path: '/checkout', page: 'checkout.page' },
    { path: '/checkout/shipping', page: 'checkout.page' },
    { path: '/checkout/create-account', page: 'checkout.page' },
    { path: '/checkout/payment', page: 'checkout-payment.page' },
    { path: '/checkout/review', page: 'checkout-review.page' },
    { path: '/payment-response/:status', page: 'payment-response.page' },
    { path: '/qr/payment', page: 'qr-payment.page' },
    { path: '/order-tracking', page: 'order-tracking.page' },
    // Legacy referral deep link (/{country}/{referralCode}) — static routes above always win ranking
    { path: '/:referralCode', page: 'referral-landing.page' }
]

export const USER_ROUTES: RouteConfig[] = [
    { path: '/user', page: 'user/account.page', auth: true },
    { path: '/user/orderhistory', page: 'user/order-history.page', auth: true },
    { path: '/user/orderhistory/:orderId', page: 'user/order-detail.page', auth: true },
    { path: '/user/order-history', page: 'user/order-history.page', auth: true },
    { path: '/user/order-history/:orderId', page: 'user/order-detail.page', auth: true },
    { path: '/user/subscriptions/*', page: 'user/subscriptions.page', auth: true },
    { path: '/user/settings/*', page: 'user/settings.page', auth: true },
    { path: '/user/invite', page: 'user/invite.page', auth: true },
    { path: '/user/payment-methods', page: 'user/payment-methods.page', auth: true }
]

export const ALL_ROUTES: RouteConfig[] = [...PUBLIC_ROUTES, ...USER_ROUTES]
